import { Icon } from '@sentinel/ui';
import { useTranslation } from 'react-i18next';
import { useCurrentSpace } from './use-current-space';

/** «PCA · Segreteria» in the topbar, icon and word (DS §13, main tab bar): it changes what the
 *  sidebar shows, so it stays at hand, also under 1100 px where the sidebar is gone. Only for
 *  who sees entries of both spaces; hiding only, the server checks every permission. */
export function SpaceSwitch() {
  const { t } = useTranslation();
  const { spaces, current, choose } = useCurrentSpace();
  if (spaces.length < 2 || current === null) return null;
  return (
    <div className="spsw" role="group" aria-label={t('shell.spaces.label')}>
      {spaces.map((space) => (
        <button
          key={space.key}
          type="button"
          aria-pressed={space.key === current.key}
          onClick={() => choose(space.key)}
        >
          <Icon name={space.space.icon} size={16} />
          {t(`shell.spaces.${space.key}`)}
        </button>
      ))}
    </div>
  );
}
